// Visual tokens per org type, established in onboarding and reused across
// the dealership filter, dealership tile, team switcher, and any future
// org-typed surface. Single source of truth for the "sky for dealership /
// amber for body shop / indigo for group" language.
//
// Tailwind v4's JIT scans .ts files for class strings, so the literal
// gradient names below are picked up at build time. If you add a new org
// type, add it here and Tailwind will mint the classes automatically.

export type OrgKind = "dealership" | "bodyshop" | "group"

export interface OrgVisualTokens {
  /** `bg-gradient-to-br from-X-500 to-X-700` — the primary tile fill. */
  gradient: string
  /** `shadow-X-600/25` — the soft glow under tiles. */
  shadow: string
  /** `from-X-200/60 to-transparent` — for ambient backdrops on cards. */
  glow: string
  /** Tinted text colour for use on light backgrounds (e.g. tile-less labels). */
  text: string
  /** Tinted soft background for "active" states. */
  softBg: string
  /** Tinted border for active filter trigger states. */
  border: string
  /** Human-friendly label. */
  label: string
}

export const ORG_VISUAL_TOKENS: Record<OrgKind, OrgVisualTokens> = {
  dealership: {
    gradient: "bg-gradient-to-br from-sky-500 to-sky-700",
    shadow: "shadow-sky-600/25",
    glow: "from-sky-200/60 to-transparent",
    text: "text-sky-900",
    softBg: "bg-sky-50/60",
    border: "border-sky-300",
    label: "Dealership",
  },
  bodyshop: {
    gradient: "bg-gradient-to-br from-amber-500 to-amber-700",
    shadow: "shadow-amber-600/25",
    glow: "from-amber-200/60 to-transparent",
    text: "text-amber-900",
    softBg: "bg-amber-50/60",
    border: "border-amber-300",
    label: "Body Shop",
  },
  group: {
    gradient: "bg-gradient-to-br from-indigo-500 to-indigo-700",
    shadow: "shadow-indigo-600/25",
    glow: "from-indigo-200/60 to-transparent",
    text: "text-indigo-900",
    softBg: "bg-indigo-50/60",
    border: "border-indigo-300",
    label: "Group",
  },
}
